import { useRef } from 'react'
import AboutAward from './AboutAward'
import AboutBanner from './AboutBanner'
import AboutHead from './AboutHead'
import AboutLogoslider from './AboutLogoslider'
import AboutPoint from './AboutPoint'
import AboutStand from './AboutStand'
import AboutVision from './AboutVision'
import AboutTimeline from './AboutTimeline'

export default function About() {
  const AboutHeadRef = useRef(null);

  const visionData = {
      leftImage: "../image/aboutvision-2.webp",
      rightImage: "../image/aboutvision-1.webp",
      heading: "Craft your vision",
      text: "Bring your ideas to life with precision-crafted interiors tailored to your lifestyle. At Saysha Interiors, we manufacture, craft, and execute solutions, transforming your vision into beautiful and functional spaces.",
  };

  return (
    <>
    <AboutBanner  
      onNavigate={() => {
    const offset = 52; // top gap
    const element = document.getElementById("about-head");
    if (element) {
      const topPosition = element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: topPosition, behavior: "smooth" });
    }
  }}/>
    <AboutTimeline id="about-head"/>
    <AboutHead/>
    <AboutPoint/>
    <AboutLogoslider/>
    <AboutStand/>
    <AboutAward/>
    <AboutVision visionData={visionData}/>
    </>
  )
}
